import React from 'react';
import { motion } from 'framer-motion';
import { LuActivity } from 'react-icons/lu';

const AuthCard = ({ children, title, description }) => (
  <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden bg-zinc-950">
    <div className="absolute inset-0 bg-gradient-to-br from-zinc-900 via-zinc-950 to-zinc-900" />
    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />
    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />
    <motion.main
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative z-10 w-full max-w-md glass-card rounded-2xl p-8 sm:p-10 border border-zinc-800/50"
    >
      <div className="flex justify-center mb-8">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center">
            <LuActivity className="w-6 h-6 text-zinc-900" />
          </div>
          <div>
            <p className="text-2xl font-semibold tracking-tight text-zinc-100">Cloud Watcher</p>
            <p className="text-xs text-zinc-500">Infrastructure Intelligence</p>
          </div>
        </div>
      </div>
      <h1 className="text-xl font-semibold text-zinc-100">{title}</h1>
      <p className="mt-2 mb-7 text-sm leading-relaxed text-zinc-500">{description}</p>
      {children}
    </motion.main>
  </div>
);

export const PasswordRequirements = () => (
  <p className="text-xs leading-relaxed text-zinc-600">
    Use at least 12 characters with uppercase, lowercase, a number, and a symbol.
  </p>
);

export default AuthCard;
